/*
 * Purpose : User Management Add or Edit screen
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */

import React,{useState, useRef, useEffect} from "react";
import {  Col,  Row,  Button,  Form,  FormGroup,  Label,  Input,  CustomInput,  Alert} from "reactstrap";

import "./AddEdituserForm.css"
import {userTableHeaders, userRoles} from "../../config/constants"
import Aux from "../../hoc/Auxilliary/Auxilliary";

const AddEditUserForm = (props) => {
    const [email, setEmail] = useState(props.stateVals.email);
    const [role, setRole] = useState(props.stateVals.role==="" ? "Common Viewer" : props.stateVals.role);
    const [submitlist, setSubmitlist] = useState(props.stateVals.submitlist==="Yes"?true:false)
    const [approvelist, setApprovelist] = useState(props.stateVals.approvelist==="Yes"?true:false)
    const [reportlist, setReportlist] = useState(props.stateVals.reportlist==="Yes"?true:false)
    const [sales_notification, setSales_notification] = useState(props.stateVals.sales_notification==="Yes"?true:false)
    const [sales_week_report, setSales_week_report] = useState(props.stateVals.sales_week_report==="Yes"?true:false)
    const [errors, setErrors] = useState({email:"",validMail:true})
    const [processing, setProcessing] = useState(false)

    const sales_notification_ref = useRef(null);
    const sales_week_report_ref = useRef(null);
   
    const validEmailRegex = RegExp(
        /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
    );
    const emailChangeHandler= (value) => {
        setEmail(value)        
        if(validEmailRegex.test(value))
        {
            setErrors({...errors, email:''})
        }
        else{
            setErrors({...errors, email:'Email is not valid!'})
        }
    }

    useEffect(() => {
      if(role==="Reviewer" || role==="Viewer"){
        setSales_notification(false)
        setSales_week_report(false)
        sales_notification_ref.current.disabled = true
        sales_week_report_ref.current.disabled = true
      }else{
        sales_notification_ref.current.disabled = false
        sales_week_report_ref.current.disabled = false
      }
    }, [role])

    const submithandler =() => {
        if(!email || !validEmailRegex.test(email)){
            setErrors({...errors, validMail:false})
        }else{
            setErrors({...errors, validMail:true})
            setProcessing(true)
            props.submithandler(email,role,submitlist,approvelist,reportlist,sales_notification,sales_week_report,props.stateVals.action)
        }
    }

    return (
    <Aux>
      <Form>
        <Alert color="danger" isOpen={!errors.validMail}>Valid Email is required.</Alert>
        <Row form>
          <Col md={12}>
            <FormGroup>
              <Label for="email">Email</Label>
              <Input
                type="email"
                name="email"
                id="email"
                placeholder=""
                value={email}
                onChange={(e) => emailChangeHandler(`${e.target.value}`)}
              />
            </FormGroup>
          </Col>
        </Row>
        {errors.email.length > 0 && <span style={{ color:"#db2269", fontSize: "1em",  display: "relative" }} >{errors.email}</span>}
        <FormGroup>
          <Label for="userRole">Role</Label>
          <Input type="select" name="select" id="userRole" defaultValue={role} onChange={(e) => setRole(`${e.target.value}`)}>
            {/* <option value="">---- select ----</option> */}
            {
              Object.keys(userRoles).map(role =><option key={role} value={role}>{role}</option>)
            }
            {/* <option value="Admin">Admin</option>
            <option value="Common Viewer">Common Viewer</option>
            <option value="Reviewer">Reviewer</option>
            <option value="Viewer">Viewer</option>
            <option value="Tool Sales Viewer">Tool Sales Viewer</option>
            <option value="Tool Sales Creator">Tool Sales Creator</option>
            <option value="Tool Sales L1 Approver">Tool Sales L1 Approver</option>
            <option value="Tool Sales L2 Approver">Tool Sales L2 Approver</option>
            <option value="Tool Sales L3 Approver">Tool Sales L3 Approver</option>
            <option value="Tool Sales L4 Approver">Tool Sales L4 Approver</option>
            <option value="Tool Sales L5 Approver">Tool Sales L5 Approver</option> */}
          </Input>
        </FormGroup>
        <Row>
          <FormGroup check>
            <Label for="exampleCheckbox">Email List</Label>
            <div>
              <CustomInput
                type="checkbox"
                id="submitlist"
                checked={submitlist}
                onChange={(e) => setSubmitlist(!submitlist)}
                label={userTableHeaders.submitlist}
              />
              <CustomInput
                type="checkbox"
                id="approvelist"
                checked={approvelist}
                onChange={(e) => setApprovelist(!approvelist)}
                label={userTableHeaders.approvelist}
              />
              <CustomInput
                type="checkbox"
                id="reportlist"
                checked={reportlist}
                onChange={(e) => setReportlist(!reportlist)}
                label={userTableHeaders.reportlist}
              />
              <CustomInput
                type="checkbox"
                id="sales_notification"
                checked={sales_notification}
                innerRef={sales_notification_ref}
                onChange={(e) => setSales_notification(!sales_notification)}
                label={userTableHeaders.sales_notification}
              />
              <CustomInput
                type="checkbox"
                id="sales_week_report"
                checked={sales_week_report}
                innerRef={sales_week_report_ref}
                onChange={(e) => setSales_week_report(!sales_week_report)}
                label={userTableHeaders.sales_week_report}
              />
            </div>
          </FormGroup>
        </Row>        
        <FormGroup style={{textAlign: "center", marginTop:"1rem"}}>
            <Row>
              <Col>
                <Button color="primary" className={"userFormBtn"} style={{backgroundColor:"#fb8734"}}
                        value="" 
                        onClick={()=>submithandler()}
                        disabled={processing}>
                        { processing && <span><i className="fa fa-spinner fa-spin"></i>  Processing... </span> }
                        { !processing && <span>Submit</span> }                                
                </Button>
              </Col>
              <Col>
                <Button color="secondary" className={"userFormBtn"} value="" onClick={props.closeHandler}>Close</Button>
              </Col>
            </Row>
        </FormGroup>
      </Form>
    </Aux>
  );
};
export default AddEditUserForm;